'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { Accordion } from '@actr/ui/src/components/accordion';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import React, { memo } from 'react';

import { FaqContent } from '@/services/models/faq';
import { faqJSONLD, MainEntity } from '@/utils/schema-org/faq';

import * as Styled from './style.css';

export type FaqBlockProps = FaqContent & {
  /** Разрешить раскрытым быть только одному вопросу
   * @default true
   * */
  onlyOne?: boolean;
}

const FaqBlock: React.FC<FaqBlockProps> = props => {
  const { title, list, onlyOne = true } = props || {};

  if (!list?.length) {
    return null;
  }

  const mainEntity: MainEntity[] = list!.map(item => ({
    '@type': 'Question',
    name: item.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.content,
    },
  }));

  const accordionItems = list.map(item => ({
    ...item,
    content: (
      <div
        dangerouslySetInnerHTML={{ __html: item.content || '' }}
      />
    ),
  }));

  return (
    <ContentBlock id="faq">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJSONLD(mainEntity)) }}
      />
      <Text tagName="h3" font="title.x2l">
        {title}
      </Text>
      <div className={Styled.MainWrapper}>
        <Accordion
          items={accordionItems}
          onlyOne={onlyOne}
        />
      </div>
    </ContentBlock>
  );
};

export default memo(FaqBlock);
